// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"8a076426","885":"35282ad6"}[chunkId] + ".chunk.js";
};